import { HttpHeaders } from '@angular/common/http';

export class Config {
  //public apiBaseUrl: string = "http://127.0.0.1:8000/";
  //public apiBaseUrl:string = "https://ngasapi.veninmaster.com/";
  public apiBaseUrl: string = "https://api.nuestrogas.pe/";
  //public apiBaseUrl: string = "http://192.168.0.159:8000/";
  // public apiBaseUrl: string = "http://192.168.0.158:8000/";
  public apiUrl: string = this.apiBaseUrl + "api/";

  public apiWeb: string = 'localhost:4200/';

  public getHeaders(type = 'application/json'): HttpHeaders {
    return new HttpHeaders({
      'content-type': type,
      'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0aWVtcG9pbmljaW8iOjE1Njg2MDQ4NTMsInRpZW1wb2ZpbiI6MTU2ODYwODQ1MywiaWR1c3VhcmlvIjoidXN1YXJpb3NzIn0.3Mrhe9lYNRC9GNl8JQ4-4lhxWcZNl5Vdr2VsvVpSiYs'
    });
  }
  /* propiedades nombres de base de api */

  public login: string = 'auth/login/';
  public precio = 'precios';
  public moneda = 'monedas';
  public clase = 'clase';
  public subclase = 'subclase';
  public sucursal = 'sucursal';
  public subgrupo = 'subgrupo';
  public articulos = 'articulos';
  public proveedor = 'proveedor';
  public zona = 'zonas';
  public ubicacion = 'ubicaciones';
  public afectoigv = 'catalog07';
  public tipoexistencia = 'tipo_exis';
  public unidadmedida = 'unidades';
  public catalogoproducto = 'catalogproduct';
  public cliente = 'clientes';
  public factura = 'factura';
  public detfactura = 'detfactu';
  public compra = 'compras';
  public detcompra = 'detcompra'
  public tip_opetbl12 = 'tip_opetbl12';
  public motivo = 'motivo';
  public ajuste = 'ajuste'
  public detajuste = 'detajuste'
  public numero = 'numero';
  public detraccion = 'catalog54'
  public kardex = 'kardex';
  public tipodocumento = 'tipodocumento';
  public zonas_ubigeo = 'zonas_ubigeo';
  public unidadsunat = 'unidadsunat';
  public guia = 'docrelaci'
  public cuota = 'docredito'
  public gasto = 'gastos'
  public tiposgastos = 'tiposgastos'
  public mediopago = 'mediopago'
  public detallecarga = 'detcargaliq'
  public ingreso = 'ingreso'
  public user = 'users'
  //public articulos:string='articulos/';

  /*Antiguos */
  public vehiculo: string = 'vehiculo';
  public tractosisterna: string = 'tractosisterna';
  public departamento: string = 'programacion';

  public conductor: string = 'conductor';
  public empresa: string = 'empresa';
  public pension: string = 'pension';
  public cargo: string = 'cargo';
  public viaje: string = 'viaje';
  public status: string = 'status';
  public certificadomedico: string = 'certificadomedico';
  public certificado: string = 'certificado';
  public tipocertificado: string = 'tipocertificado';
  public claselicencia: string = 'claselicencia';
  public categorialicencia: string = 'categorialicencia';
  public licencia: string = 'licencia';

  //public cliente:string='clientes';
  public operacion: string = 'operacion';
  public operacioncliente: string = 'operacioncliente';
  public usuario: string = 'usuario';
  public nivel: string = 'nivel';
  public perfil: string = 'perfil';
  public personal: string = 'personal';


  public sexo: string = 'sexo';
  public nacionalidad: string = 'nacionalidad';
  public estadocivil: string = 'estadocivil';

  public requerimiento: string = 'requerimiento';
  public anexo: string = 'anexo';
  public area: string = 'area';

  public tipovehiculo = 'tipovehiculo';

  public configuracionvehicular = "configuracionvehicular";
  public adquisicion = "adquisicion";
  public marca = "marca";
  public modelo = "modelo";
  public region = "region";
  public tipoproducto = "tipoproducto";
  public ruta = "ruta";
  public tiporuta = "tiporuta";
  public regionempresa = "regionempresa";
  public compartimento = "compartimento";
  public tipocargo = "tipocargo";

  public programacion = "programacion";
  public programaciondetalle = "programaciondetalle";
  public tractocisterna = "tractocisterna";
  public terminal = "terminal";
  public soat = "soat";
  public entidad = "entidad";
  public lugar = 'lugar';
  public seguimiento = 'seguimiento';
  public liquidacion = 'liquidacion'

  public clientedireccion = 'clientedireccion';

  public facturatemp = 'facturatemp';
  public detallefacturatemp = 'detallefacturatemp';
  public filtro = 'opciones-filtros'

  /* Planilla */
  public cargos_planilla   = 'cargos';
  public tipocontrato      = 'tipocontrato';
  public afp               = 'afps';
  public estado_planilla   = 'estados-planilla';
  public estado_periodo    = 'estados-periodo';
  public forma_pago        = 'formapago';
  public banco             = 'banco';
  public concepto_planilla = 'concepto-planilla';
  public periodo_planilla  = 'periodo-planilla';

}
